
import {serviceRegistrator} from './serviceRegistrator'

export default class BaseService {

	constructor(serviceName) {

		this.serviceName = serviceName;

		this.registerService(serviceName, this);
	}

	registerService(serviceName, service) {
		serviceRegistrator.registerService(serviceName, service);
	}
}


// WEBPACK FOOTER //
// ../common/services/src/baseService.js